import React from 'react'

import BrokenImage from 'assets/images/broken.svg'

interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
    readonly innerClassName?: string
}

function Image({
    src = BrokenImage,
    height = 24,
    width = 24,
    className,
    innerClassName,
    ...props
}: ImageProps): JSX.Element {
    return (
        <div className={className}>
            <img
                src={src}
                height={height}
                width={width}
                className={innerClassName}
                {...props}
                style={{
                    ...(src === BrokenImage
                        ? {
                              padding:
                                  Math.min(Number(height), Number(width)) * 0.2,
                          }
                        : {}),
                    ...props.style,
                }}
            />
        </div>
    )
}

export { Image }
